module.exports = __webpack_public_path__ + "static/media/fly0125.30fe61fc.webp";